// extracted by mini-css-extract-plugin
export default {"root":"WtSJWg","link":"C5fqaq"};